/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiAlertBulkAssignment,
    InternalApiAlertBulkAssignmentFromJSON,
    InternalApiAlertBulkAssignmentToJSON,
    InternalApiAlertExport,
    InternalApiAlertExportFromJSON,
    InternalApiAlertExportToJSON,
} from '../models';

export interface AssignAlertsBulkRequest {
    filterId: number;
    internalApiAlertBulkAssignment: InternalApiAlertBulkAssignment;
}

export interface ScheduleAlertExportRequest {
    filterId: number;
    internalApiAlertExport: InternalApiAlertExport;
}

/**
 * 
 */
export class AlertFilterResultInternalApi extends runtime.BaseAPI {

    /**
     * Assigns a subset of alerts from filter to a user or unassigns them
     */
    async assignAlertsBulkRaw(requestParameters: AssignAlertsBulkRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
            throw new runtime.RequiredError('filterId','Required parameter requestParameters.filterId was null or undefined when calling assignAlertsBulk.');
        }

        if (requestParameters.internalApiAlertBulkAssignment === null || requestParameters.internalApiAlertBulkAssignment === undefined) {
            throw new runtime.RequiredError('internalApiAlertBulkAssignment','Required parameter requestParameters.internalApiAlertBulkAssignment was null or undefined when calling assignAlertsBulk.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters/{filterId}/assign`.replace(`{${"filterId"}}`, encodeURIComponent(String(requestParameters.filterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAlertBulkAssignmentToJSON(requestParameters.internalApiAlertBulkAssignment),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Assigns a subset of alerts from filter to a user or unassigns them
     */
    async assignAlertsBulk(requestParameters: AssignAlertsBulkRequest, initOverrides?: RequestInit): Promise<void> {
        await this.assignAlertsBulkRaw(requestParameters, initOverrides);
    }

    /**
     * Schedules a task to export alerts from filter
     */
    async scheduleAlertExportRaw(requestParameters: ScheduleAlertExportRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.filterId === null || requestParameters.filterId === undefined) {
            throw new runtime.RequiredError('filterId','Required parameter requestParameters.filterId was null or undefined when calling scheduleAlertExport.');
        }

        if (requestParameters.internalApiAlertExport === null || requestParameters.internalApiAlertExport === undefined) {
            throw new runtime.RequiredError('internalApiAlertExport','Required parameter requestParameters.internalApiAlertExport was null or undefined when calling scheduleAlertExport.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/filters/{filterId}/export`.replace(`{${"filterId"}}`, encodeURIComponent(String(requestParameters.filterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiAlertExportToJSON(requestParameters.internalApiAlertExport),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Schedules a task to export alerts from filter
     */
    async scheduleAlertExport(requestParameters: ScheduleAlertExportRequest, initOverrides?: RequestInit): Promise<void> {
        await this.scheduleAlertExportRaw(requestParameters, initOverrides);
    }

}
